import { type OrganizationDetail, createOrganizationDetail } from 'models';
import { useQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import { getOrganizationDetail } from '../services';
import { getOrganizationDetailQueryKey } from './keys';

type P = {
  options?: { staleTime?: number };
  organizationId?: string;
};

export const useOrganizationDetailQuery = ({ options, organizationId }: P) =>
  useQuery<OrganizationDetail, ApiClientResponseError<DefaultResponseErrorDataObject>>({
    enabled: Boolean(organizationId),
    async queryFn() {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- Organization ID will be provided because we have enabled the query
      const { data } = await getOrganizationDetail({ organizationId: organizationId! });

      return createOrganizationDetail(data);
    },
    queryKey: getOrganizationDetailQueryKey({ organizationId }),
    ...options,
  });
